import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import '../../BusinessInfo/css/BusinessInfo.css';
import Page from '../img/QualityINSP.png';
import Text from '../../../common/Text.js';
import design1 from '../img/sotec_img_quality_1.png';
import design2 from '../img/sotec_img_quality_2.png';
import design3 from '../img/sotec_img_quality_3.png';


// 사업소개 (리뉴얼) - 설계
function QualityINSP() {
 

    useEffect(() => {


        const options = {
            // null을 설정하거나 무엇도 설정하지 않으면 브라우저 viewport가 기준 .
            root: null,
            // 타겟 요소의 50%가 루트 요소와 겹치면 콜백을 실행
            threshold: 0.5
    
        };
    
    
        // Intersection Observer 인스턴스
        const observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv1');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims = document.querySelectorAll(".Cont1_1")

        ims.forEach(img =>
            observer.observe(img)
        );
    

        // Intersection Observer 인스턴스
        const observer2 = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv2');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims2 = document.querySelectorAll(".Cont1_2")

        ims2.forEach(img =>
            observer2.observe(img)
        );
    


        // Intersection Observer 인스턴스
        const observer3 = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv3');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims3 = document.querySelectorAll(".Cont1_3")

        ims3.forEach(img =>
            observer3.observe(img)
        );

        

        // Intersection Observer 인스턴스
        const observer4 = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv4');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims4 = document.querySelectorAll(".box1_Q")

        ims4.forEach(img =>
            observer4.observe(img)
        );

        
        // Intersection Observer 인스턴스
        const observer5 = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv5');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims5 = document.querySelectorAll(".box2_Q")

        ims5.forEach(img =>
            observer5.observe(img)
        );
    

        
        // Intersection Observer 인스턴스
        const observer6 = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv6');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims6 = document.querySelectorAll(".box3_Q")

        ims6.forEach(img =>
            observer6.observe(img)
        );
            
    
          }, [])
    
    


    return (
        <div class = 'groupa' style={{display:'flex', justifyContent : 'center'}}>

        <div class="page"> 
            
        <div class="Cont_1" > 
        <div class="Cont1_1" > 
            <Text  variant="px32w700B"  className='MidTitle'>조선해양산업의 품질을 책임지는 관리 파트너</Text>
            </div>
            
            <div class="Cont1_2" > 
            <Text  variant="px28w400"  className='SmallTitle'>철저한 품질 관리와 검증으로 고객 신뢰와 안전을 보장하는 서비스를 제공합니다.</Text>
            </div>

            <div class="Cont1_3" > 
            <Text variant="px20w400" className='Contents'>품질검사는 선박의 안전성과 신뢰성을 최우선으로 보장하며 각 분야에서 철저한 품질 관리 시스템을 적용하여, 모든 설계 및 제작 과정이 최고 수준의 품질을 만족하도록 검증합니다. 고객의 요구와 규정을 충족하는 완벽한 품질 검사로 선박의 안전을 확보하고, 지속 가능한 품질 관리 솔루션을 제공합니다. </Text>
       </div>
       </div>


        <div class="boxFrame">
            
         <Text  variant="px32w700B"  className='MidTitle'>대표 프로젝트</Text>

            <div class="Contents_GRP_Q">

                <div class="box1_Q">
                     <img className="proj_img_Q"  src={design1} ></img>
                 </div>

                <div class="box2_Q">
                     <img className="proj_img_Q"  src={design2} ></img>
                </div>

                <div class="box3_Q">
                     <img className="proj_img_Q"  src={design3} ></img>
                </div>
            </div>

            <div class="box_cnt_Q">
                <Text variant="px24w600_B" className='box_cnt_KW'>AR을 이용한 블록 검사</Text>
                <div class="box_KW_cnt">
                <Text variant="px18w400_B" className='box_cnt_KW_cnt'>블록의 사이즈, 강재 종류, 각장, 몰드 방향, 모서리 사상, 작업 단계, 부재 누락,</Text> 
                <Text variant="px18w400_B" className='box_cnt_KW_cnt'>강재 등급을 AR기술을 통해 검사함으로써 검사 시간을 절약하고 정확한 검사를 수행하여 최고의 품질을 보장합니다.</Text> 
                </div>         
            </div>



        </div>

        </div >
         {/* <img class="page"  src={Page1} ></img> */}



         </div>
     );
 }
 
 export default QualityINSP;